

export default function Separator() {
  return <div className='m-2 p-2'>
    <div className="card-body h-100 d-flex flex-column justify-content-center">
      <div className='vr h-100 m-2'></div>
      <span>OR</span>
      <div className='vr h-100 m-2'></div>
    </div>
  </div>
}
